import React from 'react';

// @context TGW-1769 チャンネル一覧サイドバー。並びは「全体 → 雑談 → 作成順」固定
//   （運営の並び替え機能は要件で不採用）。未読=太字、未読メンション=件数バッジ（Slack準拠・ドット無し）。
export default function ChannelSidebar({
  circleName,
  channels,
  selectedKey,
  canManage,
  loading,
  onSelect,
  onCreateClick,
}) {
  return (
    <nav className="slackch-sidebar-inner">
      <div className="slackch-sidebar-header">{circleName}</div>
      <div className="slackch-sidebar-label">チャンネル</div>
      <ul className="slackch-channel-list">
        {loading && <li className="slackch-channel-loading">読み込み中…</li>}
        {channels.map((ch) => {
          const isSelected = ch.key === selectedKey;
          const classes = ['slackch-channel-item'];
          if (isSelected) classes.push('slackch-channel-item--selected');
          // @context TGW-1860 未読は太字（Slack準拠）。ただしメンション未読はバッジで示すため、
          //   太字にするのはメンションの付いていない未読だけに限る。
          if (!isSelected && ch.hasUnread && !ch.unreadMentionCount)
            classes.push('slackch-channel-item--unread');
          return (
            <li key={ch.key}>
              <button
                type="button"
                className={classes.join(' ')}
                onClick={() => onSelect(ch.key)}
              >
                <span className="slackch-channel-icon">
                  {ch.isPrivate ? '🔒' : '#'}
                </span>
                <span className="slackch-channel-name">{ch.name}</span>
                {!isSelected && ch.unreadMentionCount > 0 && (
                  <span className="slackch-mention-badge">
                    {ch.unreadMentionCount}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
      {canManage && (
        <button
          type="button"
          className="slackch-channel-create"
          onClick={onCreateClick}
        >
          <span className="slackch-channel-icon">＋</span> チャンネルを作成
        </button>
      )}
    </nav>
  );
}
